export default {
    'loading': '加载中',
    'trust': '【{name}委托】',
};
